import { get, post } from '../axios'

// 查询用户价值
export function ums_service_queryUserValue_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserValue`,
    map,
    option
  ).then(response => response)
}

// 修改密码
export function ums_service_modifyPassword_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/modifyPassword`,
    map,
    option
  ).then(response => response)
}

// 创建用户-自建站使用
export function ums_service_create_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/create`,
    map,
    option
  ).then(response => response)
}

// 创建用户地址
export function ums_service_createAddress_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/createAddress`,
    map,
    option
  ).then(response => response)
}

// 删除地址
export function ums_service_deleteAddressById_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/deleteAddressById`,
    map,
    option
  ).then(response => response)
}

// 删除用户
export function ums_service_deleteUser_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/deleteUser`,
    map,
    option
  ).then(response => response)
}

// 外部接口-根据userIds 查询等级levelCode
export function ums_service_level_getUserLevelList_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/level/getUserLevelList`,
    map,
    option
  ).then(response => response)
}

// 批量查询用户
export function ums_service_queryUserInfoList_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserInfoList`,
    map,
    option
  ).then(response => response)
}

// 接受订单
export function ums_service_receiveOrder_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/receiveOrder`,
    map,
    option
  ).then(response => response)
}

// 更新用户地址
export function ums_service_updateAddress_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/updateAddress`,
    map,
    option
  ).then(response => response)
}

// 更新用户基础信息
export function ums_service_updateUserInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/updateUserInfo`,
    map,
    option
  ).then(response => response)
}

// 查询指定时间范围内变化的用户信息
export function ums_service_queryUserInfoInTime_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserInfoInTime`,
    map,
    option
  ).then(response => response)
}

// 查询用户信息(积分使用)
export function ums_service_queryPageUserInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryPageUserInfo`,
    map,
    option
  ).then(response => response)
}

// 查询用户地址
export function ums_service_queryAddress_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAddress`,
    map,
    option
  ).then(response => response)
}

// 查询用户基础信息
export function ums_service_queryUserInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserInfo`,
    map,
    option
  ).then(response => response)
}

// 查询用户订阅信息
export function ums_service_queryUserNewsLetter_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserNewsLetter`,
    map,
    option
  ).then(response => response)
}

// 查询等级列表
export function ums_service_level_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/level/list`,
    map,
    option
  ).then(response => response)
}

// 校验账号是否存在
export function ums_service_checkPermission_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/checkPermission`,
    map,
    option
  ).then(response => response)
}

// 根据id查询用户地址信息
export function ums_service_queryAddressById_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAddressById`,
    map,
    option
  ).then(response => response)
}

// 根据shopify用户id查询中台用户id
export function ums_service_queryUserIdByShopifyUserId_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserIdByShopifyUserId`,
    map,
    option
  ).then(response => response)
}

// 根据三方id查询用户id(OMS)
export function ums_service_queryUserIdByThirdUserId_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserIdByThirdUserId`,
    map,
    option
  ).then(response => response)
}

// 根据用户ID查询标签
export function ums_service_tag_getTagByUserId_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/tag/getTagByUserId`,
    map,
    option
  ).then(response => response)
}

// 根据等级分页查询用户
export function ums_service_queryPageUserByLevel_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryPageUserByLevel`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱查询App和融合用户
export function ums_service_queryAppAndMixUserByEmail_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAppAndMixUserByEmail`,
    map,
    option
  ).then(response => response)
}

// 注册用户
export function ums_service_register_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/register`,
    map,
    option
  ).then(response => response)
}

// 用户地址全部改为非默认地址
export function ums_service_updateAddressUnDefaultByUserId_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/updateAddressUnDefaultByUserId`,
    map,
    option
  ).then(response => response)
}

// 用户登录(包含三方登录)
export function ums_service_login_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/login`,
    map,
    option
  ).then(response => response)
}

// 用户订阅/取消订阅--要使用该接口必须先和用户中台开发沟通
export function ums_service_userNewsLetter_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/userNewsLetter`,
    map,
    option
  ).then(response => response)
}

// 快速注册用户
export function ums_service_quickRegister_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/quickRegister`,
    map,
    option
  ).then(response => response)
}

// 用户订阅、取消 - 即时
export function ums_service_userSubOrUnsubscribe_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/userSubOrUnsubscribe`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱、站点查询用户状态
export function ums_service_queryUserStatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserStatus`,
    map,
    option
  ).then(response => response)
}

// 根据shopifyId查询userId
export function ums_service_queryUserIdByShopifyId_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserIdByShopifyId`,
    map,
    option
  ).then(response => response)
}

// 查询可用的用户群
export function user_group_list_post(map, option) {
  return post(`${process.env.VUE_APP_USER}/user/group/list`, map, option).then(
    response => response
  )
}

// 查询用户是否与对应群组匹配
export function user_group_check_post(map, option) {
  return post(`${process.env.VUE_APP_USER}/user/group/check`, map, option).then(
    response => response
  )
}

// 批量查询邮件的订阅状态
export function ums_service_marketing_queryBatchUserSubStatus_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/marketing/queryBatchUserSubStatus`,
    map,
    option
  ).then(response => response)
}

// 查询用户免邮权益
export function ums_service_userRights_queryUserFreeShippingRights_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/userRights/queryUserFreeShippingRights`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱查询一条userId，优先返回注册来源为shopify
export function ums_service_queryUserIdByEmail_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserIdByEmail`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱查询userId
export function ums_service_queryAllUserIdByEmail_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAllUserIdByEmail`,
    map,
    option
  ).then(response => response)
}

// 用户首次订阅
export function ums_service_userFirstSubscribe_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/userFirstSubscribe`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱查询所有站点的userId 列表
export function ums_service_queryAllSiteUserIdByEmail_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAllSiteUserIdByEmail`,
    map,
    option
  ).then(response => response)
}

// 根据邮箱和终端查询用户信息
export function ums_service_queryUserByEmailTerminal_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryUserByEmailTerminal`,
    map,
    option
  ).then(response => response)
}

// 发送验证码
export function ums_service_sendVerifyCode_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/sendVerifyCode`,
    map,
    option
  ).then(response => response)
}

// 用户手机号订阅
export function ums_service_smsSubscribe_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/smsSubscribe`,
    map,
    option
  ).then(response => response)
}

// 批量查询用户常用语言编码
export function ums_service_batchQueryLangCode_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/batchQueryLangCode`,
    map,
    option
  ).then(response => response)
}

// 查询偏好问答列表
export function ums_service_queryAllPreferences_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAllPreferences`,
    map,
    option
  ).then(response => response)
}

// 新增用户偏好选择
export function ums_service_addUserPreference_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/addUserPreference`,
    map,
    option
  ).then(response => response)
}

// 查询尺寸问答列表
export function ums_service_queryAllMeasurements_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAllMeasurements`,
    map,
    option
  ).then(response => response)
}

// 新增用户尺寸选择
export function ums_service_addUserMeasurement_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/addUserMeasurement`,
    map,
    option
  ).then(response => response)
}

// 查询取消订阅供用户选择的问答列表
export function ums_service_queryAllChooses_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/queryAllChooses`,
    map,
    option
  ).then(response => response)
}

// 新增用户实际选择的答案
export function ums_service_addUserChoose_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/addUserChoose`,
    map,
    option
  ).then(response => response)
}

// 校验Emarsys传参中的用户id
export function sps_service_checkContactIdentify_post(map, option) {
  return post(
    `${process.env.VUE_APP_SPS_SERVICE}/sps-service/checkContactIdentify`,
    map,
    option
  ).then(response => response)
}

// 获取用户等级
export function ums_service_user_level_get(map, option) {
  return get(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/user/level`,
    map,
    option
  ).then(response => response)
}

// 查询用户是否与自定义的用户群组匹配
export function ums_service_user_group_defined_check_post(map, option) {
  return post(
    `${process.env.VUE_APP_UMS_SERVICE}/ums-service/user/group/defined/check`,
    map,
    option
  ).then(response => response)
}
